module.exports = __webpack_public_path__ + "img/home-bg-02.3905d0c7.png";